import React, { FunctionComponent } from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
// eslint-disable-next-line import/no-duplicates
import { format, parseISO } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';

export const DATE_FORMAT = 'dd.MM.yyyy';

const DateFormatter: FunctionComponent<DataTypeProvider.ValueFormatterProps> = ({
  value,
}) => {
  if (!value) return null;

  return <>{format(parseISO(value), DATE_FORMAT, { locale: ru })}</>;
};

interface DateTypeProviderProps {
  for: string[];
}

const DateTypeProvider = (props: DateTypeProviderProps) => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
);

export default DateTypeProvider;
